<div>
  <div id="navContainer">
    <div class="titleArrow">
      <button class="back" (click)="onChildClick()">
        <img [src]="arrowPath" alt="Back" />
      </button>
      <h2 class="timedOutTitle">Es ist ein Fehler aufgetreten</h2>
    </div>
  </div>
  <p class="timedOutDescription">
    Beim Laden dieser Seite ist ein Problem aufgetreten. Bitte aktualisiere die Seite oder versuche
    es später erneut. Unser Team ist bereits informiert und kümmert sich um die Behebung des
    Fehlers.
  </p>
</div>
